import { IconCalendar16 } from '@warp-ds/icons/react';
import { formatReadableDateShort, safeParseISO } from 'shared/util/datetime-fns';
import { thousandSeparated } from 'shared/util/formatting';
import type { HotelOffer } from '@/interfaces';
import { getNumberOfPax } from '@/lib/utils/hotelResultItemUtil';
import { SupplierLogo } from '../resultList/images/SupplierLogo';

export type HotelResultHeaderProps = Pick<HotelOffer, 'supplier' | 'duration' | 'departureDate' | 'returnDate' | 'pricePerPerson'> & {
    numberOfAdults?: number;
    numberOfChildren?: number;
};

export const HotelResultHeader = ({
    supplier,
    duration,
    departureDate,
    returnDate,
    pricePerPerson,
    numberOfAdults,
    numberOfChildren,
}: HotelResultHeaderProps) => {
    const parsedDepartureDate = safeParseISO(departureDate);
    const parsedReturnDate = safeParseISO(returnDate);

    const numPax = getNumberOfPax(numberOfAdults, numberOfChildren);
    const paxText = numPax === 1 ? `${numPax} person` : `${numPax} personer`;

    const srLabel = `Tilbud: ${duration} dagers reise, 
        fra ${formatReadableDateShort(parsedDepartureDate)} 
        til ${formatReadableDateShort(parsedReturnDate)}, 
        pris per person ${thousandSeparated(pricePerPerson)} kroner, 
        ${paxText}`.replace(/\s+/g, ' ');

    return (
        <>
            <span className="sr-only">{srLabel}</span>
            <div aria-hidden="true" className="flex flex-col md:flex-row w-full md:items-center md:justify-between gap-8 ">
                <div className="flex flex-row md:items-center gap-8">
                    <SupplierLogo supplier={supplier} />
                    <span className="font-bold text-s">{duration} dagers reise</span>
                </div>
                <div className="flex flex-row items-center gap-8 capitalize md:lowercase  text-s">
                    <IconCalendar16 className="md:hidden " />
                    {parsedDepartureDate && <time dateTime={departureDate}>{formatReadableDateShort(parsedDepartureDate)}</time>}
                    {' - '}
                    {parsedReturnDate && <time dateTime={returnDate}>{formatReadableDateShort(parsedReturnDate)}</time>}
                </div>
                <div className="flex flex-row items-center gap-8 text-s pr-8 md:flex-row-reverse">
                    <strong>{thousandSeparated(pricePerPerson)} kr</strong> {paxText}, pris per person
                </div>
            </div>
        </>
    );
};
